export const getTypeAction = (approvalType, approvalAction) => `${approvalType}-${approvalAction}`;